import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const QuestionFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12ZM12 8.25C11.7804 8.24979 11.5646 8.30744 11.3743 8.41716C11.1841 8.52688 11.0261 8.6848 10.9163 8.875C10.837 9.02235 10.7289 9.15227 10.5985 9.25708C10.468 9.36188 10.3179 9.43943 10.1569 9.48513C9.99593 9.53082 9.82743 9.54374 9.66138 9.52311C9.49533 9.50248 9.33512 9.44871 9.19023 9.36501C9.04534 9.28131 8.91874 9.16937 8.81791 9.03584C8.71709 8.9023 8.64411 8.74987 8.60329 8.5876C8.56246 8.42533 8.55464 8.25652 8.58027 8.09117C8.6059 7.92582 8.66447 7.7673 8.7525 7.625C9.16527 6.91014 9.80239 6.35145 10.565 6.03558C11.3277 5.7197 12.1732 5.6643 12.9706 5.87795C13.7679 6.0916 14.4725 6.56237 14.975 7.21725C15.4776 7.87213 15.75 8.67453 15.75 9.5C15.7502 10.2758 15.5099 11.0325 15.0622 11.6661C14.6145 12.2996 13.9813 12.7787 13.25 13.0375V13.25C13.25 13.5815 13.1183 13.8995 12.8839 14.1339C12.6495 14.3683 12.3315 14.5 12 14.5C11.6685 14.5 11.3505 14.3683 11.1161 14.1339C10.8817 13.8995 10.75 13.5815 10.75 13.25V12C10.75 11.6685 10.8817 11.3505 11.1161 11.1161C11.3505 10.8817 11.6685 10.75 12 10.75C12.3315 10.75 12.6495 10.6183 12.8839 10.3839C13.1183 10.1495 13.25 9.83152 13.25 9.5C13.25 9.16848 13.1183 8.85054 12.8839 8.61612C12.6495 8.3817 12.3315 8.25 12 8.25ZM12 18.25C12.3315 18.25 12.6495 18.1183 12.8839 17.8839C13.1183 17.6495 13.25 17.3315 13.25 17C13.25 16.6685 13.1183 16.3505 12.8839 16.1161C12.6495 15.8817 12.3315 15.75 12 15.75C11.6685 15.75 11.3505 15.8817 11.1161 16.1161C10.8817 16.3505 10.75 16.6685 10.75 17C10.75 17.3315 10.8817 17.6495 11.1161 17.8839C11.3505 18.1183 11.6685 18.25 12 18.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

QuestionFilledIcon.displayName = 'QuestionFilledIcon';
